import { useTranslation } from 'react-i18next';

import LogoCertified from '../../assets/icons/logo-cpo.svg';
import Procedure from '../../components/Procedure/Procedure';
import Exclusion from '../../components/Services/Exclusion';
import { getTranslation } from '../../components/Specifications/Utils';
import { addDaysToDate, formatDate } from '../../utils/helpers/date.helper';

import { displayGuarantee } from './Utils';

const getWatchNameTranslationType = (translations) => {
  if (!Array.isArray(translations)) {
    return null;
  }

  return translations.reduce((translationType, translation) => {
    if (
      translation?.Type === 'PORTAL_CATALOG_LINE' &&
      translation.Translation
    ) {
      return 'PORTAL_CATALOG_LINE';
    }

    if (translation?.Type === 'MODEL_NAME' && translation.Translation) {
      return 'MODEL_NAME';
    }

    return translationType;
  }, null);
};

const CpoProduct = ({ rightToLeft, watchData, businessData }) => {
  const { t } = useTranslation();

  const configuration = watchData?.Configuration;
  const serialNumber = watchData?.SerialNumber;
  const reference = configuration?.Rmc || configuration?.Model;
  const warrantyEndDate = watchData?.WarrantyEndDate;
  const translations = businessData?.[0]?.Translations;
  const watchNameTranslationType = getWatchNameTranslationType(translations);

  const watchName = watchNameTranslationType
    ? getTranslation(businessData, watchNameTranslationType)
    : 'ROLEX';

  const warrantyExpiryDate = addDaysToDate(warrantyEndDate, 31);
  const formattedWarrantyExpiryDate = formatDate(
    warrantyExpiryDate,
    t('dateFormat'),
  );

  return (
    <>
      <img
        className="logoCpo"
        src={LogoCertified}
        alt={t('accessibility.cpoLogoImgAlt', {
          defaultValue: 'Rolex Certified Pre-Owned',
        })}
      />

      <div className="productPage">
        <div className="content">
          <div className="card">
            <div className="cardContent">
              <div className="serialNr">
                {t('serialNr')} {serialNumber}
                {reference && (
                  <>
                    {' '}
                    | {t('reference')} {reference}
                  </>
                )}
              </div>

              <div className="watchName">{watchName}</div>

              {displayGuarantee(
                warrantyEndDate,
                t('underGuarantee'),
                t('serviceGuarantee'),
                t('monthYearFormat'),
              )}
            </div>
          </div>

          <div className="card">
            <div className="guarantee">
              <div className="heading">{t('cpoGuarantee')}</div>

              <Exclusion services={watchData?.Services} />

              <div className="heading">{t('cpoExpiryDate')}</div>

              {warrantyExpiryDate && formattedWarrantyExpiryDate && (
                <time dateTime={warrantyExpiryDate.toISOString()}>
                  {formattedWarrantyExpiryDate}
                </time>
              )}
            </div>
          </div>

          <Procedure rightToLeft={rightToLeft} text={t('procedureCpo')} />
        </div>
      </div>
    </>
  );
};

export default CpoProduct;
